import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchLayout } from '../BillWatchLayout';
import { BillWatchMenus } from "../BillWatchMenus";
import { BillWatchProps } from "../BillWatchProps";

interface HomePageProps extends NSARouterMakerResult, BillWatchProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <BillWatchLayout
            {...props}
            action={{
                menus: {
                    "Book a free call": [BillWatchMenus.BookCall()]
                }
            }}
        >
            <NSAHomePage {...props} /></BillWatchLayout >
    );
}